module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pages-home-block', {
    attrs: {
      "block": _vm.block
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d040622"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/infoDentists/OurMission.vue
// module id = 275
// module chunks = 0